import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { TIER_MAP } from '@pumpkincare/wellness';

import { formatCurrency } from '../../../shared/utils/currencyUtils';
import PetDetailHeader from '../pet-detail-header';
import { wellnessRenewalChangeConfirmationModalStyle } from './wellness-renewal-change-confirmation-modal-style';

function WellnessRenewalChangeConfirmationModal(props) {
  const {
    onClose = () => {},
    isOpen = false,
    onConfirmChanges = () => {},
    loading = false,
    petData = {},
    renewalChangeData = {},
  } = props;

  const classes = wellnessRenewalChangeConfirmationModalStyle();

  const isChargedAnnually = petData.wellness_plans.find(
    plan => plan.status === 'renew_pending'
  )?.is_annualized;
  const months = isChargedAnnually ? 11 : 1;

  const changesMade = [
    {
      visible: true,
      current_value:
        TIER_MAP[
          petData.wellness_plans
            .find(plan => plan.status === 'renew_pending')
            ?.tier.replace('.', '-')
        ],
      new_value: TIER_MAP[renewalChangeData.tier],
    },
  ];

  return (
    <Dialog maxWidth='md' open={isOpen} onClose={onClose}>
      <DialogTitle>
        <Typography className={classes.modalTitle}>Confirm Changes:</Typography>
      </DialogTitle>
      <DialogContent>
        <div className={classnames(classes.modalContentDetail)}>
          <div className={classes.petPlanHeaderContainer}>
            <Typography className={classes.petTitle}>{`${
              petData.name || ''
            }'s Plan`}</Typography>
          </div>

          <PetDetailHeader petData={petData} showLine={true} />

          <div className={classes.petPlanHeaderContainer}>
            <Typography className={classes.petTitle}>Changes Made:</Typography>
          </div>

          {changesMade.map((item, idx) => {
            return item.visible ? (
              <div
                key={`${item.current_value}-${idx}`}
                className={classes.changesMadeContainer}
              >
                <Typography className={classes.changesMade}>
                  {item.current_value}
                </Typography>
                <ArrowRightAltIcon className={classes.changesMadeIcon} />
                <Typography className={classes.changesMade}>
                  {item.new_value}
                </Typography>
              </div>
            ) : null;
          })}

          <div className={classes.petPlanHeaderContainer}>
            <Typography className={classes.totalValues}>{`${
              isChargedAnnually ? 'Annual' : 'Monthly'
            } Subtotal:`}</Typography>
            <Typography className={classes.totalValues}>
              {formatCurrency(parseFloat(renewalChangeData.price) * months, {
                areCents: false,
              })}
            </Typography>
          </div>

          <div className={classes.petPlanHeaderContainer}>
            <Typography className={classes.totalValues}>
              {`${isChargedAnnually ? 'Annual' : 'Monthly'} Transaction Fee:`}
            </Typography>
            <Typography className={classes.totalValues}>
              {formatCurrency(0, { areCents: false })}
            </Typography>
          </div>

          <div className={classes.petPlanHeaderContainer}>
            <Typography className={classes.petPlanTitle}>{`${
              isChargedAnnually ? 'Annual' : 'Monthly'
            } Grand Total:`}</Typography>
            <Typography className={classes.petPlanTitle}>
              {formatCurrency(parseFloat(renewalChangeData.price) * months, {
                areCents: false,
              })}
            </Typography>
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <div className={classes.buttonContainer}>
          <Button
            fullWidth
            disabled={loading}
            type='submit'
            className={classes.saveButton}
            onClick={onConfirmChanges}
          >
            SAVE CHANGES
          </Button>
          <Button
            fullWidth
            disabled={loading}
            onClick={onClose}
            className={classes.cancelButton}
          >
            CANCEL
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}

WellnessRenewalChangeConfirmationModal.propTypes = {
  onClose: PropTypes.func,
  onConfirmChanges: PropTypes.func,
  isOpen: PropTypes.bool,
  loading: PropTypes.bool,
  petData: PropTypes.object,
  renewalChangeData: PropTypes.object,
};

export default WellnessRenewalChangeConfirmationModal;
